export default __webpack_public_path__ + "static/devops_a1_cloud_christophe_g-203a858f6ee09e7e9bdb89222f6e8c09.jpg";